
















































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import Icon from '@/components/Icon.vue'
import Confirm from '@/components/Confirm.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { EUserPermissions, IFacilityCollectionFlowsResult } from '@zunta/configurations'
import Api from '@/api'
import { User } from '@/classes/User'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'

@Component({
  components: {
    Table,
    Card,
    SearchInput,
    Icon,
    Confirm
  }
})
export default class BillingFlow extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User

  collectionFlowForDelete: number | string | null = null

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    usePagination: true,
    rowClick: this.goEdit,
    fetchFunction: this.fetchItems,
    columns: [
      {
        minWidth: '300px',
        width: 90,
        key: 'payerType',
        searchKey: 'payerType',
        label: 'Payers',
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        width: 10,
        minWidth: '40px',
        class: 'text-right',
        key: 'actions'
      }
    ]
  }

  get totalFlows () {
    return this.$store.state.facility.collectionFlowTableTotal
  }

  get items () {
    return this.$store.state.facility.collectionFlowTableItems
  }

  get facilityId () {
    return this.$route.params.id
  }

  async fetchItems (filters: any) {
    await this.facilityModuleInstance.fetchCollectionFlowTableItems({
      facilityId: this.facilityId,
      filters
    })
  }

  getDeleteFlowMessage () {
    const flow = this.items.find((item: IFacilityCollectionFlowsResult) => {
      if (this.collectionFlowForDelete) {
        return item.collectionFlowId.toString() === this.collectionFlowForDelete.toString()
      }
      return false
    })

    if (!flow) {
      return ''
    }

    if (flow.payerTypes.length > 0) {
      return 'Are you sure you want to delete this flow? There are Payers assigned to this flow. If you choose to delete the flow, please remember to assign a new flow.'
    }

    return 'Are you sure you want to delete this flow? This cannot be undone'
  }

  goEdit (item: any) {
    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_COLLECTIONS_FLOW)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Modify Flow`,
        icon: 'warning'
      })
      return
    }

    this.$locationManager.rememberAndGoTo({
      name: 'management-facilities-create-billing-flow',
      params: {
        facilityId: this.facilityId,
        collectionFlowId: item.collectionFlowId.toString()
      }
    })
  }

  closeDeleteConfirmation () {
    this.collectionFlowForDelete = null
  }

  openDeleteConfiration (collectionFlow: number | string) {
    this.collectionFlowForDelete = collectionFlow
  }

  async deleteCollectionFlow () {
    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_COLLECTIONS_FLOW)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: 'Modify Collection Flow',
        icon: 'warning'
      })
      return
    }
    if (!this.collectionFlowForDelete) {
      return
    }
    const response = await this.facilityModuleInstance.deleteCollectionFlow(this.collectionFlowForDelete)
    if (response === 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Collection Flow successfully deleted!',
        header: 'Delete Collection Flow',
        icon: 'check'
      })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Something went wrong',
        header: 'Delete Collection Flow',
        icon: 'warning'
      })
    }
    this.collectionFlowForDelete = null
  }
}
